import { useMemo } from 'react';
import { PRIMITIVE_COLORS, SEMANTIC_COLORS, REDESIGN_COLORS } from '../residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const RESIDENTS_DESKTOP_COLORS = {
  PRIMARY_BACKGROUND: REDESIGN_COLORS.bg.base,
  SECONDARY_BACKGROUND: REDESIGN_COLORS.bg.gradientStart,
  CIRCLE_ICON_BACKGROUND: PRIMITIVE_COLORS.gray700,
  BUTTON_PRIMARY: PRIMITIVE_COLORS.resioBlue,
  BUTTON_SECONDARY: REDESIGN_COLORS.text.secondary,
  BUTTON_TERTIARY: PRIMITIVE_COLORS.resioBlue,
  BUTTON_ACTIVE_PRIMARY: REDESIGN_COLORS.card.bg,
  BORDER_PRIMARY: PRIMITIVE_COLORS.resioBlueLight,
  BORDER_SECONDARY: REDESIGN_COLORS.card.border,
  ICON_ACTIVE: REDESIGN_COLORS.text.primary,
  ICON_INACTIVE: REDESIGN_COLORS.text.muted,
  TEXT_PRIMARY: REDESIGN_COLORS.text.primary,
  TEXT_SECONDARY: PRIMITIVE_COLORS.resioBlueLight,
  TEXT_TERTIARY: REDESIGN_COLORS.text.subtle,
  TEXT_SUCCESS: PRIMITIVE_COLORS.successGreen,
  TEXT_ATTENTION: PRIMITIVE_COLORS.resioBlueAttention,
  HOVER_PRIMARY: REDESIGN_COLORS.card.bg,
  ACCOUNT_TAB: PRIMITIVE_COLORS.resioBlue,
  linkedAccounts: {
    invitationTabsBorder: PRIMITIVE_COLORS.resioPurple,
    accountsTabsBorder: PRIMITIVE_COLORS.resioBlueLight,
    howTabsBorder: PRIMITIVE_COLORS.resioPink,
  },
} as const;

export function useDesktopColors() {
  const { semantic, components, colors } = useThemeColors();
  return useMemo(() => ({
    PRIMARY_BACKGROUND: colors.bg.base,
    SECONDARY_BACKGROUND: colors.bg.gradientStart,
    CIRCLE_ICON_BACKGROUND: semantic.border.secondary,
    BUTTON_PRIMARY: semantic.interactive.primary,
    BUTTON_SECONDARY: colors.text.secondary,
    BUTTON_TERTIARY: semantic.interactive.primary,
    BUTTON_ACTIVE_PRIMARY: colors.card.bg,
    BORDER_PRIMARY: semantic.interactive.primaryHover,
    BORDER_SECONDARY: colors.card.border,
    ICON_ACTIVE: colors.text.primary,
    ICON_INACTIVE: colors.text.muted,
    TEXT_PRIMARY: colors.text.primary,
    TEXT_SECONDARY: semantic.interactive.primaryHover,
    TEXT_TERTIARY: colors.text.subtle,
    TEXT_SUCCESS: semantic.status.success,
    TEXT_ATTENTION: semantic.interactive.primary,
    HOVER_PRIMARY: colors.card.bg,
    ACCOUNT_TAB: semantic.interactive.primary,
    linkedAccounts: {
      invitationTabsBorder: components.nav.headerPurple,
      accountsTabsBorder: semantic.interactive.primaryHover,
      howTabsBorder: semantic.interactive.secondary,
    },
  }), [semantic, components, colors]);
}
